import { useEffect } from 'react';
import { useDataModel } from '@thd-nucleus/data-sources';
import thdCustomer from '@thd-olt-global/thd-customer';
import * as helpers from '../components/InstantCheckoutHelper';
import { track } from '../components/analytics/instant-checkout-analytics';

export const useUserDetails = ({ itemId, storeId }) => {
  const productOptions = {
    ssr: false,
    variables: {
      itemId,
      storeId,
    },
  };

  const {
    data: productData,
    loading: productLoading,
    error: productError,
  } = useDataModel('clientOnlyProduct', productOptions);
  const { fulfillment = {} } = productData?.product || {};

  const shouldFetchInstantCheckout =
    (thdCustomer.userID || thdCustomer.svocID) &&
    productData &&
    fulfillment &&
    helpers.isInstantCheckoutEligible(fulfillment);

  const { THD_USER, THD_USER_SESSION, IC_ROADS } = helpers.getCookies([
    'THD_USER',
    'IC_ROADS',
    'THD_USER_SESSION',
  ]);

  const {
    data: icData,
    loading: icLoading,
    error: icError,
  } = useDataModel('instantCheckout', {
    skip: !shouldFetchInstantCheckout || !(THD_USER && THD_USER_SESSION && IC_ROADS),
    variables: {
      userId: thdCustomer.userID,
      customerAccountId: thdCustomer.svocID,
      thdUserCookie: THD_USER,
      icRoadsCookie: IC_ROADS,
    },
    context: {
      headers: {
        Authorization: THD_USER_SESSION,
      },
    },
  });

  useEffect(() => {
    if (productData && fulfillment) {
      if (
        !helpers.isInstantCheckoutEligible(fulfillment) &&
        helpers.isGuestInstantCheckoutEligible(fulfillment)
      ) {
        track({ ICTemplate: 'DEFAULT' });
      }
    }
  }, [productData]);
  useEffect(() => {
    if (icData && !icError) {
      track({ ICTemplate: icData?.instantCheckout?.displayOption });
    }
  }, [icData, icLoading]);
  const ICModel = icData?.instantCheckout;

  return [
    {
      ICTemplate: ICModel?.displayOption || 'DEFAULT',
      addressCity: ICModel?.addressCity || '',
      addressZipCode: ICModel?.addressZipCode || '',
      xref: ICModel?.xref || '',
      displayCardBrand: ICModel?.displayCardBrand || '',
      loading: productLoading || icLoading,
    },
  ];
};
